
import React from 'react';
import GrammarPageLayout from '../components/grammar-page-layout';
import GrammarExplanation from './device-verbs-explanation';
const mainimage = '/Images/computerprogramming.webp';

const sections = [
  { label: "Grammar", description: "Do this exercise to practice grammar.", type: "quiz", subtype: "deviceverbs" },
];


const DeviceVerbs = () => (
  <GrammarPageLayout
    level="B2"
    title="Device Verbs"
    image={mainimage}
    ExplanationComponent={GrammarExplanation}
    sections={sections}
    seoTitle="Free English Device Verbs Exercises"
    seoDescription="Describe what machines and devices do with verbs like convert, emit, transmit and detect. B2 level exercises."
    relatedCategory="grammar-exercises"
    relatedLevel="B2"
  />
);

export default DeviceVerbs;
